interface Specifity {
  id: number;
  name: string;
}

export const specifities: Specifity[] = [
  {
    id: 1,
    name: 'surgeon',
  },
  {
    id: 2,
    name: 'dermatologist',
  },
  {
    id: 3,
    name: 'oncologist',
  },
  {
    id: 4,
    name: 'cardiologist',
  },
  {
    id: 5,
    name: 'therapist',
  },
  {
    id: 6,
    name: 'ophthalmologist',
  },
  {
    id: 7,
    name: 'neurologist',
  },
];
